


































































































































































































































































































































































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { Getter, State, Action } from 'vuex-class';
import { Project } from '@/models/project';
import { Album, PhotoAlbum } from '@/models/album';
import S3Image from '../components/s3-image/S3Image.vue';
import { Validations } from 'vuelidate-property-decorators';
import { required } from 'vuelidate/lib/validators';
// @ts-ignore: no d.ts file
import { vTeleport } from '@desislavsd/vue-teleport';
import { photoService } from '@/services';
import { albumsService } from '@/services';
import { NotificationMessage, Socket } from '@/store/types';
import { Logger, Storage } from 'aws-amplify';
import { User } from '@/models/user';
const logger = new Logger('AlbumView');

// Définir les interfaces nécessaires
interface S3Object {
  key: string;
  // Ajoutez d'autres propriétés si nécessaire
}

interface S3Photo {
  url: string;
  key: string;
  isSelected?: boolean;
}

@Component({
  components: {
    S3Image,
    vTeleport,
  },
})
export default class AlbumView extends Vue {
  @Prop(String) private id!: string;

  @State('projects', { namespace: 'projects' }) private projects!: Project[];
  @State('socket') private socketMessage!: Socket;
  @State('premium', { namespace: 'profile' }) private isPremium!: boolean;
  @State('locale', { namespace: 'profile' }) locale!: string;
  @State('user', { namespace: 'profile' }) private user!: User;

  @Action('loadOneAlbum', { namespace: 'album' }) private loadOneAlbum!: (albumId: string) => Promise<Album>;
  @Action('loadAlbum', { namespace: 'album' }) private loadAlbum!: (payload: {
    projectId: string;
    cameraId: string;
  }) => Promise<Album[]>;
  @Action('addPhoto', { namespace: 'album' }) private readonly addPhoto!: (payload: {
    albumId: string;
    photoId: string;
  }) => Promise<void>;
  @Action('removePhoto', { namespace: 'album' }) private readonly removePhoto!: (payload: {
    albumId: string;
    photoId: string;
  }) => Promise<void>;
  @Action('connectSocket') private connectSocket!: () => Promise<void>;
  @Action('disconnectSocket') private disconnectSocket!: () => Promise<void>;

  @Getter('albumWithId', { namespace: 'album' }) private albumWithId!: (id: string) => Album | undefined;
  @Getter('projectWithId', { namespace: 'projects' }) private projectWithId!: (id: string) => Project | undefined;
  @Getter('albumFiltered', { namespace: 'album' }) private readonly albumFiltered!: (id: string) => Album[];

  private album: Album | null = null;
  private project: Project | null = null;
  private selectedAlbum = '';
  private MAX_PHOTO = 10;

  private s3Photos: S3Photo[] = [];

  private visibleCameraPhotos = true;
  private visibleImportedPhotos = true;

  private showAlertCantDownload = false;
  private zipGenerating = false;
  private zipLink: string[] | null = null;
  private zoomedS3PhotoIndex: number | null = null;
  private get showModalZip(): boolean {
    return this.zipGenerating || this.zipLink !== null;
  }
  private set showModalZip(b: boolean) {
    if (b === false) {
      this.zipGenerating = false;
      this.zipLink = null;
    }
  }
  public get dateFormat(): string {
    return this.locale === 'en' ? 'MM / DD / YYYY - HH:mm' : 'DD / MM / YYYY - HH:mm';
  }

  public get guest(): boolean | undefined {
    return this.project?.guestId.includes(this.user.id);
  }

  public get zoomedS3Photo() {
    return this.zoomedS3PhotoIndex !== null ? this.s3Photos[this.zoomedS3PhotoIndex] : null;
  }

  public get isAdmin(): boolean {
    return (
      this.user !== undefined &&
      this.project !== undefined &&
      this.project !== null &&
      (this.project.owner.id === this.user.id || this.project.administratorId.includes(this.user.id))
    );
  }

  @Validations()
  private validations = {
    selectedAlbum: { required },
  };

  public mounted(): void {
    this.loadDataAlbum();
    this.fetchS3Photos();
  }

  private async onDeleteAlbum(): Promise<void> {
    try {
      const confirmed = await this.$bvModal.msgBoxConfirm(this.$tc('albumview.deletealbum'), {
        title: this.$tc('albumview.pleaseconfirm'),
        size: 'sm',
        buttonSize: 'sm',
        okVariant: 'danger',
        okTitle: this.$tc('albumview.confirmyes'),
        cancelTitle: this.$tc('albumview.confirmno'),
        footerClass: 'p-2',
        centered: true,
      });

      if (confirmed && this.album?.id) {
        // Utilisation de l'albumsService importé pour supprimer l'album
        await albumsService.deleteAlbum({ id: this.album.id });

        // Afficher un message de succès
        this.$bvToast.toast('Album supprimé avec succès', {
          title: 'Succès',
          variant: 'success',
          solid: true,
        });

        // Rediriger après la suppression
        this.$router.push({ name: 'plateformcentral', params: { id: this.album.projectId } });
      }
    } catch (error) {
      console.error("Erreur lors de la suppression de l'album :", error);
      this.$bvToast.toast("Erreur lors de la suppression de l'album", {
        title: 'Erreur',
        variant: 'danger',
        solid: true,
      });
    }
  }

  public beforeDestroy(): void {
    logger.info('beforeDestroy');
    // called when the route that renders this component is about to
    // be navigated away from.
    // has access to `this` component instance.
    this.disconnectSocket();
  }

  public get breadcrumbs(): unknown[] {
    const items = [
      {
        text: this.$tc('global.project', 2),
        to: '/',
      },
    ];

    if (this.project) {
      items.push({
        text: this.project.name,
        to: '/project/' + this.project.id,
      });
    }
    if (this.album) {
      items.push({
        text: this.album.name,
        to: '#',
      });
    }
    return items;
  }

  public get selectedPhotos(): PhotoAlbum[] {
    return this.album ? this.album.photos.filter((photo) => photo.isSelected) : [];
  }

  public get selectedS3Photos() {
    return this.s3Photos.filter((photo) => photo.isSelected);
  }

  public get zoomedPhoto(): PhotoAlbum | null {
    if (this.zoomedPhotoIndex !== undefined && this.album) {
      return this.album.photos[this.zoomedPhotoIndex];
    } else {
      return null;
    }
  }

  public get zoomedPhotoIndex(): number | undefined {
    if (this.$route.query.zoom !== undefined) {
      return parseInt(this.$route.query.zoom as string, 10);
    } else {
      return undefined;
    }
  }

  public set zoomedPhotoIndex(photoIndex: number | undefined) {
    if (photoIndex === undefined) {
      this.$router.push({ path: this.$route.path, query: { ...this.$route.query, zoom: undefined } });
    } else if (this.$route.query !== { ...this.$route.query, zoom: photoIndex.toString() }) {
      this.$router.push({ path: this.$route.path, query: { ...this.$route.query, zoom: photoIndex.toString() } });
    }
  }

  public unzoom(): void {
    this.zoomedPhotoIndex = undefined;
  }

  public zoomPrevious(): void {
    if (this.zoomedPhotoIndex !== undefined && this.zoomedPhotoIndex >= 0) {
      this.zoomedPhotoIndex = this.zoomedPhotoIndex - 1;
    }
  }

  public zoomNext(): void {
    if (this.zoomedPhotoIndex !== undefined && this.album && this.zoomedPhotoIndex < this.album.photos.length - 1) {
      this.zoomedPhotoIndex = this.zoomedPhotoIndex + 1;
    }
  }

  private triggerFileInput(): void {
    (this.$refs.fileInput as HTMLInputElement).click();
  }

  private async fetchS3Photos(): Promise<void> {
    try {
      if (this.album && this.album.cameraId) {
        // Utilise Storage.list pour lister les photos
        const folderPath = `${this.album.cameraId}/album/${this.album.name}/`;
        const photos: S3Object[] = await Storage.list(folderPath); // Liste les objets dans le dossier spécifié

        if (photos && photos.length > 0) {
          // Récupérer les URL signées pour chaque photo
          const signedUrls: S3Photo[] = await Promise.all(
            photos.map(async (photo: S3Object) => {
              const url = (await Storage.get(photo.key, { expires: 3600 })) as string; // Assertion de type ajoutée
              return {
                url,
                key: photo.key || '',
                isSelected: false, // Définit la sélection par défaut sur false
              };
            })
          );
          this.s3Photos = signedUrls;
        } else {
          console.log('Aucune photo trouvée dans le bucket.');
        }
      }
    } catch (err) {
      console.error('Erreur lors de la récupération des objets S3:', err);
    }
  }

  public zoomPreviousS3(): void {
    if (this.zoomedS3PhotoIndex !== null && this.zoomedS3PhotoIndex > 0) {
      this.zoomedS3PhotoIndex--;
    }
  }

  public zoomNextS3(): void {
    if (this.zoomedS3PhotoIndex !== null && this.zoomedS3PhotoIndex < this.s3Photos.length - 1) {
      this.zoomedS3PhotoIndex++;
    }
  }

  public unzoomS3(): void {
    this.zoomedS3PhotoIndex = null;
  }

  // Gestion de la sélection des photos importées
  public onS3PhotoClicked(index: number): void {
    Vue.set(this.s3Photos[index], 'isSelected', !this.s3Photos[index].isSelected);
  }

  public async uploadFileToS3(file: File) {
    if (!this.album || !this.album.cameraId || !this.album.name) {
      console.error('Album non défini ou informations manquantes');
      return;
    }

    const folder = this.album.cameraId; // Utilise l'ID de la caméra comme nom de dossier
    const filename = file.name; // Nom du fichier
    const albumID = this.album.name; // Nom de l'album

    // Affiche un toast loader pendant l'upload
    const toastId = this.$bvToast.toast(`Chargement du fichier ${filename} en cours...`, {
      title: 'Chargement en cours',
      variant: 'info',
      solid: true,
      toaster: 'b-toaster-top-right',
      noAutoHide: false, // Le toast reste visible jusqu'à ce qu'il soit explicitement fermé
      autoHideDelay: 5000, // Pas de délai automatique
    });

    try {
      // Utilise Storage.put d'Amazon Amplify pour l'upload sans clés d'accès manuelles
      await Storage.put(`${folder}/album/${albumID}/${filename}`, file, {
        contentType: file.type,
      });

      // Affiche un message de succès
      this.$bvToast.toast(`Fichier ${filename} importé avec succès`, {
        title: 'Importation réussie',
        variant: 'success',
        solid: true,
      });

      this.loadDataAlbum(); // Recharger les données de l'album après l'upload
    } catch (error) {
      console.error("Erreur lors de l'upload du fichier:", error);
      this.$bvToast.toast(`Une erreur est survenue lors de l'importation de ${filename}`, {
        title: 'Erreur',
        variant: 'danger',
        solid: true,
      });
    }
  }

  // Gestion des fichiers sélectionnés
  public async onFileSelected(event: Event): Promise<void> {
    const input = event.target as HTMLInputElement;
    if (input.files && this.album && this.album.cameraId) {
      const files = Array.from(input.files); // Récupère tous les fichiers sélectionnés

      for (const file of files) {
        // Envoyer chaque fichier individuellement
        await this.uploadFileToS3(file);
      }
    } else {
      this.$bvToast.toast(`Aucun fichier sélectionné ou album non défini.`, {
        title: 'Erreur',
        variant: 'danger',
        solid: true,
      });
    }
  }

  private loadDataAlbum(): void {
    this.loadOneAlbum(this.id).then((album) => {
      logger.info('loadDataAlbum', { album });
      this.album = album;
      if (this.album) {
        this.project = this.projectWithId(this.album.projectId) || null;
        this.loadAlbum({ projectId: this.album.projectId, cameraId: this.album.cameraId }).then(() => {
          // Attendez que tout soit bien chargé avant d'appeler this.fetchS3Photos();
          this.fetchS3Photos();
        });
      }
    });
  }
  private selectAll(): void {
    if (this.album && this.album.photos) {
      Vue.set(
        this.album,
        'photos',
        this.album.photos.map((photo) => {
          photo.isSelected = true;
          return photo;
        })
      );
    }

    // Sélectionner toutes les photos importées
    this.s3Photos = this.s3Photos.map((photo: any) => {
      photo.isSelected = true;
      return photo;
    });
  }

  private unselectAll(): void {
    if (this.album && this.album.photos) {
      Vue.set(
        this.album,
        'photos',
        this.album.photos.map((photo) => {
          photo.isSelected = false;
          return photo;
        })
      );
    }

    // Désélectionner toutes les photos importées
    this.s3Photos = this.s3Photos.map((photo: any) => {
      photo.isSelected = false;
      return photo;
    });
  }

  public onClickedPhoto(index: number, isS3Photo = false): void {
    if (isS3Photo) {
      // Gérer la sélection des photos importées (s3Photos)
      Vue.set(this.s3Photos[index], 'isSelected', !this.s3Photos[index].isSelected);
    } else if (this.album && this.album.photos) {
      Vue.set(
        this.album,
        'photos',
        this.album.photos.map((photo, i) => {
          if (i === index) {
            if (photo.isSelected === true) {
              photo.isSelected = false;
            } else {
              photo.isSelected = true;
            }
          }
          return photo;
        })
      );
    }
  }

  private async onDeletePhotos(): Promise<void> {
    const hasImportedPhotos = this.s3Photos.length > 0;

    this.$bvModal
      .msgBoxConfirm(
        this.$tc('albumview.modaldeletephotobody', this.selectedPhotos.length + this.selectedS3Photos.length),
        {
          title: this.$tc('albumview.pleaseconfirm'),
          size: 'sm',
          buttonSize: 'sm',
          okVariant: 'danger',
          okTitle: this.$tc('albumview.confirmyes'),
          cancelTitle: this.$tc('albumview.confirmno'),
          footerClass: 'p-2',
          hideHeaderClose: false,
          centered: true,
        }
      )
      .then(async (value: boolean | null) => {
        if (value === true) {
          // Suppression des photos de la caméra
          for (const photo of this.selectedPhotos) {
            await this.removePhoto({ albumId: this.id, photoId: photo.id });
          }

          // Si aucune photo n'est présente après suppression, mettre à jour l'album
          if (this.album?.photos.length === 0) {
            this.album.photos = []; // Définir à un tableau vide
          }

          // Recharge l'album pour obtenir le dernier état des photos après suppression
          await this.loadOneAlbum(this.id).then((album) => {
            this.album = album;
          });

          // Suppression des photos importées
          for (const photo of this.selectedS3Photos) {
            const photoKey = photo.key;
            await this.onDeleteS3Photo(photoKey);
          }

          // Vérifie s'il reste des photos (de la caméra ou importées)
          const remainingCameraPhotos = this.album?.photos.length ?? 0;
          const remainingImportedPhotos = this.s3Photos.length;

          if (remainingCameraPhotos === 0 && remainingImportedPhotos === 0) {
            try {
              // Appel à la méthode pour supprimer l'album
              if (this.album?.id) {
                await albumsService.deleteAlbum({ id: this.album.id });
              }
              // Rediriger après la suppression de l'album
              this.$router.push({ name: 'plateformcentral', params: { id: this.project?.id ?? '' } });
            } catch (error) {
              console.error("Erreur lors de la suppression de l'album :", error);
              this.$bvToast.toast("Erreur lors de la suppression de l'album", {
                title: 'Erreur',
                variant: 'danger',
                solid: true,
              });
            }
          } else {
            // Sinon, juste mettre à jour les photos sans supprimer l'album
            this.loadOneAlbum(this.id)
              .then((album) => {
                this.album = album;
              })
              .catch((error) => {
                console.error(error);
                this.$router.push({ name: 'plateformcentral', params: { id: this.project?.id ?? '' } });
              });
          }
        }
      })
      .catch((err) => {
        console.error(err);
      });
  }

  public async onDeleteS3Photo(photoKey: string): Promise<void> {
    if (!photoKey) {
      console.error('La clé de la photo est manquante ou incorrecte.');
      return;
    }

    try {
      // Utilise Storage.remove pour supprimer la photo dans le bucket S3
      await Storage.remove(photoKey);

      this.$bvToast.toast('Photo supprimée avec succès', {
        title: 'Suppression réussie',
        variant: 'success',
        solid: true,
      });

      // Mise à jour des photos après suppression
      this.s3Photos = this.s3Photos.filter((photo) => photo.key !== photoKey);
    } catch (error) {
      console.error('Erreur lors de la suppression de la photo:', error);
      this.$bvToast.toast('Erreur lors de la suppression de la photo', {
        title: 'Erreur',
        variant: 'danger',
        solid: true,
      });
    }
  }

  private async onSelectAlbum(albumSelected: string) {
    logger.info('onSelectAlbum ' + albumSelected);
    this.$v.selectedAlbum.$touch();
    if (!this.$v.selectedAlbum.$invalid) {
      for (const photo of this.selectedPhotos) {
        await this.addPhoto({ albumId: albumSelected, photoId: photo.id });
        await this.removePhoto({ albumId: this.id, photoId: photo.id });
      }
      if (this.selectedPhotos.length === this.album?.photos.length) {
        this.$router.push({ name: 'plateformcentral', params: { id: this.project?.id ?? '' } });
      } else {
        this.loadOneAlbum(this.id)
          .then((album) => {
            this.album = album;
            this.onClose();
            this.unselectAll();
            this.selectedAlbum = '';
          })
          .catch((error) => {
            logger.error('', error);
            this.$router.push({ name: 'plateformcentral', params: { id: this.id } });
          });
      }
    }
  }

  private onShow(): void {
    logger.info('onShow');
    // eslint-disable-next-line vue/custom-event-name-casing
    this.$root.$emit('bv::show::popover', 'popover-change-album');
  }

  private onClose(): void {
    this.$v.selectedAlbum.$reset();
    this.selectedAlbum = '';
    // eslint-disable-next-line vue/custom-event-name-casing
    this.$root.$emit('bv::hide::popover', 'popover-change-album');
  }

  private async download(): Promise<void> {
    if (this.album !== null) {
      this.zipLink = null;
      this.zipGenerating = true;
      await this.connectSocket();
      photoService.requestZipPhoto(
        this.album.projectId,
        this.selectedPhotos.map((photo) => photo.id)
      );
    }
  }

  @Watch('socketMessage.message')
  private onSocketMessageChange(val: NotificationMessage) {
    if (val && val.zip && val.zip === 'ready') {
      logger.info('onSocketMessageChange', { val });
      if (this.showModalZip) {
        this.zipGenerating = false;
        this.zipLink = (val.url as string).split('|');
      }
    }
  }

  @Watch('projects')
  private onStateProjectLoaded(val?: Project[], oldVal?: Project[]) {
    logger.info('onStateProjectLoaded', { val, oldVal });
    if (this.album !== null) {
      this.project = this.projectWithId(this.album.projectId) || null;
    }
  }
}
